import * as SavaneJS from '@rhinov/savane-js';
import { IFilter } from './IFilter';
import { FiltersWidget } from '../FiltersWidget';
import { ObjectTypeFilter } from '../Filters/ObjectTypeFilter';
import { FiltersController } from './FiltersController';
import { GenericElement } from '../Elements/GenericElement';
import { PinBoardsFilterWidget } from '../FiltersWidgets/PinBoardsFilterWidget';
import { GroupsFilterWidget } from '../FiltersWidgets/GroupsFilterWidget';

declare var AssetManagerServices: any;
declare var Savane: any;
declare var EntityDefaultPropertiesManager: any;
declare const HP_CONFIG: any;
declare var PlanManager: any;

export interface FiltersData {
    style: any[] | null;
    roomType: any[] | null;
    objectType: any[] | null;
    coatingType: any[] | null;
    svg: any | null;
    tags: any[] | null;
    joineryType: any[] | null;
    technicalElementType: any[] | null;
    showPriority: string | null;
    showUnavailable: boolean;
    showForGraphicArtists: boolean;
    showRSE: boolean;
    showContentFactory: boolean;
    showNewObjects: boolean;
    minRangePrice: number;
    maxRangePrice: number;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    minRangeWidth: number;
    maxRangeWidth: number;
    minWidth?: number | undefined;
    maxWidth?: number | undefined;
    public_pinboards: boolean | any[];
    sort: { price?: number, width: number; };
    useColorSearch: boolean;
    color: string;
    universes?: Universes;
    magicsearch?: any;
    couchElement?: any;
    name?: string;
    hang?: string;
    coatingTypes?: any[] | null;
    objectTypes?: any[] | null;
    joineryTypes?: any[] | null;
    assets?: any[] | null;
    bathroomElement?: any | null;
    kitchenElement?: GenericElement | null;
    storageElementDepth?: any | null;
    storageElementHeight?: any | null;
    storageElementType?: any | null;
    public_groups?: boolean | any[];
    datas?: any[];
    previousPage?: number;
    scroll?: number;
}

interface Universes {
    indoor: boolean;
    bathroom: boolean;
    outdoor: boolean;
    junior: boolean;
    B2B: boolean
}

export abstract class FilterGroup {

    id: string;
    name: string;
    resource: any;
    icon: string;
    container: string;
    showUnavailable: boolean = false;
    showForGraphicArtists: boolean = false;
    showRSE: boolean = false;
    showContentFactory: boolean = false;
    showNewObjects: boolean = false;
    showPriority: any | null = null;
    minRangePrice: number = 0;
    maxRangePrice: number = 5000;
    minPrice?: number;
    maxPrice?: number;
    minRangeWidth: number = 0;
    maxRangeWidth: number = 5000;
    minWidth?: number;
    maxWidth?: number;
    sort: { price?: number, width: number; } = { price: 0, width: 0 };
    hang: string = '';
    public_pinboards: boolean | any[] = false;
    public_groups: boolean | any[] = false;
    previousPage?: number;
    universes?: Universes;
    filtersFunction: string;
    filters: IFilter[] = [];
    controller: FiltersController;
    isDestroyed: boolean

    // Selection variables
    static styles: null | any[];
    static boStyles: null | any[];
    static roomTypes: null | any[];
    static boRoomTypes: null | any[];
    static coatingTypes: null | any[];
    static technicalElementTypes: any;
    static joineryTypes: any;
    static SVGs: any;
    static seeOnlyMDMObjects: boolean = true;
    static roomBudget: any[] = [];
    static totalBudget: number = 0;
    static kitchenPrice: number | null = null;
    static defaultFilters?: any[] | null;
    static cache: { name: string | null, list: any[] } = { name: null, list: [] };
    static roomCollapsed: any[] = [];
    static pricesAndSupply: any[] | null = null;
    static selectedPinboardId: any;
    static selectedGroupdId: any;


    constructor() {
        this.isDestroyed = false;
    }

    html(): void {
        this.isDestroyed = false;
        let container = document.getElementById(this.container);
        if (!container) {
            return;
        }
        container.innerHTML = this.filtersHtml();
    }

    filtersHtml(): string {
        let html = '';
        this.filters.forEach((filter: IFilter) => {
            html += `${filter.html()}`;
        });
        return html;
    }

    destroy(): void {
        this.isDestroyed = true;
        this.controller.destroy();
        this.filters.forEach(filter => filter.destroy());
    }

    static place_camera: boolean = true;
    static place_light: boolean = true;
    static send_preview: boolean = true;
    static toggle_sketch: boolean = true;
    static worktop_edit: boolean = true;
    static smart_designer: boolean = true;
    static mdmBusiness: boolean = false;
    static $rootScope: any;

    static filters: FiltersData = {
        style: null,
        roomType: null,
        objectType: null,
        coatingType: null,
        svg: null,
        tags: null,
        joineryType: null,
        technicalElementType: null,
        showPriority: (AssetManagerServices.ARRMGR_COUNTRY_ID === 175 || AssetManagerServices.ARRMGR_COUNTRY_ID === 176 || AssetManagerServices.ARRMGR_COUNTRY_ID === 177) ? 'MDM' : 'REFERENCED',
        showUnavailable: false,
        showForGraphicArtists: false,
        showRSE: false,
        showContentFactory: false,
        showNewObjects: false,
        minRangePrice: 0,
        maxRangePrice: 5000,
        minRangeWidth: 0,
        maxRangeWidth: 5000,
        public_pinboards: false,
        sort: { price: 0, width: 0 },
        useColorSearch: false,
        color: '#ff0000',
        scroll: 0,
    };
    // Boolean to handle if filters are loaded or not
    static saveFilters: IFilter[] = [];
    static smartSearchActivated: number = parseInt(SavaneJS.SavaneCookie.getCookie("Rhinov-DesignerFilter-SmartSearchEnabled", "" + 0));
    static currentPage: number = 1;
    static projectResults: any[] | null = null;
    static selectedTemplate: any;
    static pagination: any;
    static assets_groups: any | null = null;

    static pinboards: any[] = [];
    static actualList: any;
    static objectTypes: any;
    // Store last filters to set them when enabling filtering
    static savedEntity: any;

    static allLapeyreFormeoHandleModels = [];
    // All coatings for lapeyre formeo mirror
    static allLapeyreFormeoMirrorCoatings = [];
    // All coatings for lapeyre formeo cabinets
    static allLapeyreFormeoCabinetCoatings = [];
    // All coatings for lapeyre storage cabinets
    static allLapeyreStorageCabinetCoatings: any[] = [];
    // All coatings for Lapeyre storage doors
    static allLapeyreStorageDoorCoatings = [];
    // All coatings for Lapeyre storage doors
    static allLapeyreStorageShelfCoatings = [];
    static allLapeyreStorageHandleModels = [];
    // All coatings for ixina cabinets
    static allIxinaCabinetCoatings = [];
    // All coatings for ixina doors
    static allIxinaDoorCoatings = [];
    // Strings to avoid AM reloads if same call that previous call
    static allIxinaDoorCoatingNewString: string | null = "";
    static allIxinaDoorCoatingCurrentString: string | null = "";
    // All coatings for ixina sinks
    static allIxinaSinkCoatings = [];
    // All coatings for ixina mixers
    static allIxinaMixerCoatings = [];
    // All coatings for Ixina kitchen element gutter
    static allIxinaGutterCoatings = [];
    // All coatings for Ixina kitchen element plinths
    static allIxinaPlinthCoatings = [];
    // All handles for Ixina kitchen
    static allKitchenHandleModels = [];

    static previewAuto: boolean = false;
    static previewAutoIntervalId: any;
    static previewAutoWindow: any | null = null;
    static guidForPreview: any;
    static previewCameraId: number = -2;
    static freeCamera: any | null = null;

    //#region Listeners 
    static displayGroupListener = Savane.eventsManager.instance.addListener(Savane.Events.TOGGLE_DISPLAY_GROUPS, function () {
        if (FilterGroup.selectedTemplate) {
            FilterGroup.selectTemplate(FilterGroup.selectedTemplate);
        }
    });

    static refreshPinboardListener = Savane.eventsManager.instance.addListener(Savane.Events.REFRESH_PINBOARDS, function () {
        FilterGroup.updatePinboards(FilterGroup.filters);
    });

    static refreshGroupsListener = Savane.eventsManager.instance.addListener(Savane.Events.REFRESH_ASSETS_GROUPS_LIST, function () {
        FilterGroup.updateAssetsGroupsLists(FilterGroup.filters);
    });

    static enableObjectFilters = Savane.eventsManager.instance.addListener(Savane.Events.ENABLE_OBJECT_FILTERS_CHANGED, function (event) {
        if (navigator.userAgent.toLowerCase().indexOf('electron') === -1) {
            ObjectTypeFilter.objectFilterActivated = parseInt(Savane.SavaneCookie.getCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 0));
        }
        if (ObjectTypeFilter.objectFilters()) {
            FiltersWidget.lastObjectType = null;

            for (var i = 0; i < PlanManager.getInstance().selectedEntities.length; i++) {
                if (PlanManager.getInstance().selectedEntities[i].isArrangementObjectEntity()) {
                    FilterGroup.savedEntity = PlanManager.getInstance().selectedEntities[i];

                    Savane.eventsManager.instance.dispatch(Savane.Events.SET_FILTERS, {
                        entity: FilterGroup.savedEntity,
                        forceUpdate: event.userData.forceUpdate
                    });
                    break;
                }
            }
        }
        ObjectTypeFilter.updateObjectFiltersIcon();
    });



    //Listener when a new results call for request filters
    static resultListener: any;

    // Hide/Display area surface (button in the floating bar)
    static setFilters = Savane.eventsManager.instance.addListener(Savane.Events.SET_FILTERS, function (event: any) {
        if (!FiltersWidget.currentFiltersGroup || (!ObjectTypeFilter.objectFilters() && FiltersWidget.currentFiltersGroup.id !== 'budgets')) {
            return;
        }

        if (!event.userData.entity || event.userData.entity.entityType !== Savane.SceneConstants.EntityType.ArrangementObject) {
            return;
        }

        if (!event.userData.forceUpdate && FilterGroup.savedEntity) {
            if (ObjectTypeFilter.objectFiltersBySize()) {
                if (FiltersWidget.lastObjectType === event.userData.entity.objectType) {
                    if (event.userData.entity.anchor[1] < 0) {
                        if (FilterGroup.savedEntity.length === event.userData.entity.length && FilterGroup.savedEntity.height === event.userData.entity.height) {
                            return;
                        }
                    } else {
                        if (FilterGroup.savedEntity.length === event.userData.entity.length && FilterGroup.savedEntity.width === event.userData.entity.width) {
                            return;
                        }
                    }
                }
            } else {
                if (FiltersWidget.lastObjectType === event.userData.entity.objectType) {
                    return;
                }
            }
        }

        FilterGroup.savedEntity = Savane.EntityFactory.cloneEntity(event.userData.entity);
        FiltersWidget.lastObjectType = FilterGroup.savedEntity.objectType;

        if (FiltersWidget.currentFiltersGroup.id === 'assets' || FiltersWidget.currentFiltersGroup.id === 'bathroom' || FiltersWidget.currentFiltersGroup.id === 'budgets') {
            FilterGroup.filters.name = '';

            let scopeObjectType = FilterGroup.recurSearchObjectType(FilterGroup.savedEntity.objectType, FilterGroup.objectTypes);

            if (scopeObjectType !== null) {
                FilterGroup.filters.objectType = [];
                FilterGroup.filters.objectType.push(scopeObjectType);
                while (scopeObjectType.parent.parent !== null) {
                    scopeObjectType = FilterGroup.recurSearchObjectType(scopeObjectType.parent._id, FilterGroup.objectTypes);
                    FilterGroup.filters.objectType.push(scopeObjectType);
                }
                FilterGroup.filters.objectType = FilterGroup.filters.objectType.reverse();
                const objectTypeFilter = ObjectTypeFilter.getInstance(FiltersWidget.currentFiltersGroup);
                // The budget tab uses objectType but doesn't have an ObjectTypeFilter
                if (objectTypeFilter) {
                    objectTypeFilter.updateSelection();
                }
                FilterGroup.updateFilters(FilterGroup.filters);
            }
        }
    });
    //#endregion

    static updateEntityProperty(name, item) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        switch (name) {
            case 'floorHeight':
            case 'height':
                return function (value) {
                    if (arguments.length === 0 || value === undefined) {
                        return Math.floor(item.position[2] / 10);
                    } else {
                        item.startTemporary();
                        var position = Savane.math.vec3.clone(item.position);
                        position[2] = value * 10;
                        item.position = position;
                        FiltersWidget.EmitEntityParamEditedEvent(item, name);
                        if (item.isRenderCameraEntity()) {
                            instance.executeCommand(new Savane.Commands.EditRenderCameraCommand(item, true));
                        } else {
                            instance.executeCommand(new Savane.Commands.EditEntityCommand(item));
                        }
                    }
                };
            default:
                return function (value) {
                    if (arguments.length === 0 || value === undefined) {
                        if (typeof item[name] === "number") {
                            return Math.round(item[name]);
                        }
                        return item[name];
                    } else {
                        item.startTemporary();
                        item[name] = value;
                        FiltersWidget.EmitEntityParamEditedEvent(item, name);
                        if (item.isRenderCameraEntity()) {
                            instance.executeCommand(new Savane.Commands.EditRenderCameraCommand(item, true));
                        } else {
                            instance.executeCommand(new Savane.Commands.EditEntityCommand(item));
                        }
                    }
                };
        }

    };

    static deleteEntity(item) {
        FilterGroup.selectEntity(item);
        Savane.eventsManager.instance.dispatch(Savane.Events.DELETE_EVENT);
    };

    static setDropdownValue(name, item, value) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        item.startTemporary();
        item[name] = value;
        if (item.isRenderCameraEntity()) {
            instance.executeCommand(new Savane.Commands.EditRenderCameraCommand(item, true));
        } else {
            instance.executeCommand(new Savane.Commands.EditEntityCommand(item));
            if (name === "temperature") {
                FiltersWidget.initLightColorPicker(item);

            }
        }
    }

    static isItemSelected(itemID) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return ('vertical-align: middle');
        }

        if ((instance.selectedEntities.length === 1) && (instance.selectedEntities[0].id === itemID)) {
            return ('vertical-align: middle;font-weight: bold;text-decoration-line: underline;color:#E0D000');
        }

        return ('vertical-align: middle');
    };

    static selectEntity(item) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        instance.updateItemsSelected([item], false, false);
        FiltersWidget.EmitEntityParamEditedEvent(item)
    };

    static getCabinetCoatingPreviewUrl(coating: any): string | null {
        if (coating !== null) {
            var url = AssetManagerServices.getUrl() +
                'api/v1/coatings/' +
                coating._id +
                '/medias/previews/preview1-sm.webp';

            return (url);
        } else return null;
    };

    static resetRoomBudget() {
        FilterGroup.seeOnlyMDMObjects = !FilterGroup.seeOnlyMDMObjects;
        FilterGroup.roomBudget = [];
        FilterGroup.totalBudget = 0;
    }

    static isRoomCollapsed(room: any): boolean {
        var roomId: number;
        if (room) {
            roomId = room.id;
        }
        else {
            roomId = -1;
        }
        var idx = FilterGroup.roomCollapsed.findIndex(function (roomC: any) { return (roomC.id === roomId) });

        if (idx === -1) {
            FilterGroup.roomCollapsed.push({ id: roomId, hidden: true });
            return (true);
        }
        else {
            return (FilterGroup.roomCollapsed[idx].hidden);
        }
    };

    static updateSVG(item: any) {
        PlanManager.getInstance().selectedSVGBrush = item._id;
    }

    static getAllObjectPricesAndSupply(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            var instance = PlanManager.getInstance();
            if (!instance) {
                reject('No PlanManager instance found !');
                return;
            }
            var allObjects = instance.world.arrangementObjects;
            var allIds = [];

            var allObjectsIds = '';
            for (var i = 0; i < allObjects.length; i++) {
                if (!allObjects[i]._excludeFromShoppingList && allIds.indexOf(allObjects[i].objectId) === -1) {
                    allIds.push(allObjects[i].objectId)
                    if (i !== 0) {
                        allObjectsIds += ',';
                    }
                    allObjectsIds += allObjects[i].objectId;
                }
            }

            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.ARRANGEMENTS, '&fields=_id,price,supply&q._id.in=' + allObjectsIds, function (res) {
                FilterGroup.pricesAndSupply = res.data.resources;

                FilterGroup.roomBudget = [];
                FilterGroup.totalBudget = 0;

                resolve();
            });
        });
        return promise;
    }

    static getRoomName(room: any): string {
        var roomFunctionality = null;
        if (room) {
            roomFunctionality = room.getComponent(Savane.ComponentConstants.ComponentType.Functionality);
        }
        var name = "+ ";
        if (!FilterGroup.isRoomCollapsed(room)) {
            name = "- ";
        }
        if (!roomFunctionality) {
            name += 'Hors Pièce';
        }
        else {
            if (roomFunctionality.functionalityName === '') {
                name += room.name;
            }
            else {
                name += roomFunctionality.functionalityName;
            }
        }

        return (name);
    };

    static getRoomBudget(room: any): string {
        var roomId: number;
        if (room) {
            roomId = room.id;
        }
        else {
            roomId = -1;
        }

        var idx = FilterGroup.roomBudget.findIndex(function (roomBudget) { return (roomBudget.id === roomId) });

        if (idx !== -1) {
            return (FilterGroup.roomBudget[idx].budget.toFixed(2));
        }

        var budget = 0;

        if (FilterGroup.pricesAndSupply) {
            var roomObjects: any[];
            if (room) {
                roomObjects = room.arrangementObjectsRec;
            }
            else {
                var allObjects = PlanManager.getInstance().scene.arrangementObjects;
                roomObjects = allObjects.filter(obj => obj.room === null ? true : false);
            }

            for (var i = 0; i < roomObjects.length; i++) {
                if (FilterGroup.seeOnlyMDMObjects && roomObjects[i].manufacturer._id !== '579b5fc0d7ee59f805e3c065') {
                    continue;
                }
                var priceIndex = FilterGroup.pricesAndSupply.findIndex(function (asset) { return asset._id === roomObjects[i].objectId });

                if (priceIndex !== -1 && FilterGroup.pricesAndSupply[priceIndex].price && FilterGroup.pricesAndSupply[priceIndex].price.value) {
                    budget += FilterGroup.pricesAndSupply[priceIndex].price.value;
                }
            }
        }
        var toAdd = { id: roomId, budget: budget, details: null };
        FilterGroup.roomBudget.push(toAdd);

        return (toAdd.budget.toFixed(2));
    };

    static getRoomDetails(room: any): any[] {
        var roomId: number;
        if (room) {
            roomId = room.id;
        }
        else {
            roomId = -1;
        }
        var idx = FilterGroup.roomBudget.findIndex(function (roomBudget) { return (roomBudget.id === roomId) });

        if (idx !== -1 && FilterGroup.roomBudget[idx].details !== null) {
            return (FilterGroup.roomBudget[idx].details);
        }
        var result = [];

        if (idx === -1) {
            return result;
        }

        var instance = PlanManager.getInstance();
        if (!instance) {
            return (result);
        }

        if (FilterGroup.pricesAndSupply) {
            var roomObjects: any[];
            if (room) {
                roomObjects = room.arrangementObjectsRec;
            }
            else {
                var allObjects: any[] = PlanManager.getInstance().scene.arrangementObjects;
                roomObjects = allObjects.filter(obj => obj.room === null ? true : false);
            }

            for (var i = 0; i < roomObjects.length; i++) {
                if (FilterGroup.seeOnlyMDMObjects && roomObjects[i].manufacturer._id !== '579b5fc0d7ee59f805e3c065') {
                    continue;
                }
                var priceIndex = FilterGroup.pricesAndSupply.findIndex(function (asset) { return asset._id === roomObjects[i].objectId });

                if (priceIndex !== -1 && FilterGroup.pricesAndSupply[priceIndex].price && FilterGroup.pricesAndSupply[priceIndex].price.value) {
                    var arrayIndex = result.findIndex(function (asset) { return asset.objectId === roomObjects[i].objectId });

                    if (arrayIndex !== -1) {
                        result[arrayIndex].quantity++;
                        result[arrayIndex].total += FilterGroup.pricesAndSupply[priceIndex].price.value;
                    }
                    else {
                        var available = 0;
                        if (FilterGroup.pricesAndSupply[priceIndex].supply) {
                            for (var j = 0; j < FilterGroup.pricesAndSupply[priceIndex].supply.warehouseStockAvailabilities.length; j++) {
                                if (FilterGroup.pricesAndSupply[priceIndex].supply.warehouseStockAvailabilities[j].warehouse === "SAINT_MARTIN_DE_CRAU") {
                                    available = FilterGroup.pricesAndSupply[priceIndex].supply.warehouseStockAvailabilities[j].quantity;
                                }
                            }
                        }
                        result.push({ objectId: roomObjects[i].objectId, name: roomObjects[i].name, quantity: 1, availability: available, total: FilterGroup.pricesAndSupply[priceIndex].price.value });

                    }
                }
            }
        }

        FilterGroup.roomBudget[idx].details = result.sort((a, b) => a.total > b.total ? -1 : 1);

        return (FilterGroup.roomBudget[idx].details);
    };

    static getRoomObjectThumbnailUrl(item: any) {
        return AssetManagerServices.getUrl() + 'api/v1/assets/' + item.objectId + '/medias/previews/preview1-sm.webp';
    };

    static isBudgetObjectSelected(itemID: string) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return ('');
        }
        for (var i = 0; i < instance.selectedEntities.length; i++) {
            if (instance.selectedEntities[i].objectId === itemID) {
                return ('font-weight: bold;text-decoration-line: underline;color:#E0D000');
            }
        }

        return ('');
    };

    static clickBudgetObject(object: any) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }
        var allObjects = instance.scene.arrangementObjects;
        var objectsToSelect = allObjects.filter(obj => obj.objectId === object.objectId ? true : false);

        Savane.eventsManager.instance.dispatch(Savane.Events.CHANGE_EDITOR_SELECTION,
            {
                selection: objectsToSelect,
                keepSelected: false,
                showTulip: false
            });
    };

    static getTotalBudget(): string {
        if (FilterGroup.totalBudget !== 0) {
            return (FilterGroup.totalBudget.toFixed(2));
        }
        var budget = 0;

        if (FilterGroup.pricesAndSupply) {
            var instance = PlanManager.getInstance();
            if (!instance) {
                return;
            }
            var allObjects = instance.world.arrangementObjects;

            for (var i = 0; i < allObjects.length; i++) {
                if (FilterGroup.seeOnlyMDMObjects && allObjects[i].manufacturer._id !== '579b5fc0d7ee59f805e3c065') {
                    continue;
                }
                var priceIndex = FilterGroup.pricesAndSupply.findIndex(function (asset) { return asset._id === allObjects[i].objectId });

                if (priceIndex !== -1 && FilterGroup.pricesAndSupply[priceIndex].price && FilterGroup.pricesAndSupply[priceIndex].price.value) {
                    budget += FilterGroup.pricesAndSupply[priceIndex].price.value;
                }
            }
        }

        FilterGroup.totalBudget = budget;

        return (FilterGroup.totalBudget.toFixed(2));
    };

    static toggleRoomCollapsed(room: any) {
        var roomId: number;
        if (room) {
            roomId = room.id;
        }
        else {
            roomId = -1;
        }
        var idx = FilterGroup.roomCollapsed.findIndex(function (roomC) { return (roomC.id === roomId) });

        if (idx !== -1) {
            FilterGroup.roomCollapsed[idx].hidden = !FilterGroup.roomCollapsed[idx].hidden;
        }
    };

    static isCoatingUsed(coating: any, customName: string, objectTypeList: any[]): boolean {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return false;
        }

        if (FilterGroup.cache.name !== customName) {
            FilterGroup.cache.name = customName;
            FilterGroup.cache.list = [];

            var entities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);
            if (entities.length === 0) {
                entities = FilterGroup.collectCustomizableEntities(instance.world.currentScene.currentFloor.iArrangements);
            }

            for (var i = 0; i < entities.length; ++i) {
                var item = entities[i];

                if (objectTypeList.indexOf(item.objectType) === -1) continue;

                for (var j = 0; j < item.customization.parts.length; j++) {
                    if (item.customization.parts[j].name.includes(customName) && (FilterGroup.cache.list.indexOf(item.customization.parts[j].id_coating) === -1)) {
                        FilterGroup.cache.list.push(item.customization.parts[j].id_coating);
                    }
                }
            }
        }

        return (FilterGroup.cache.list.indexOf(coating._id) !== -1);
    }

    static getHandlePreviewUrl(model: any): string {
        if (model !== null) {
            var url = AssetManagerServices.getUrl() +
                'api/v1/assets/' +
                model._id +
                '/medias/previews/preview1-sm.webp';

            return (url);
        }
    }

    static changeAssetsGroupsPage(page: number): Promise<void> {
        let promise = new Promise<void>((resolve) => {
            FilterGroup.currentPage = page;
            FilterGroup.filters.previousPage = page;
            FilterGroup.assets_groups = null;

            if (!FiltersWidget.designer) {
                resolve();
                return;
            }

            AssetManagerServices.getAssetsGroupsLists(FilterGroup.filters.public_groups, FiltersWidget.designer.mail, FilterGroup.currentPage, 20, function (result) {
                if (result) {
                    FilterGroup.pagination = FilterGroup.generatePagination(result['totalRows'], 20, FilterGroup.currentPage);
                    FilterGroup.assets_groups = result['resources'];
                } else {
                    FilterGroup.pagination = null;
                    FilterGroup.assets_groups = [];
                }
                resolve();
                setTimeout(function () {
                    FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                    Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                }, 50);
            });
        });

        return promise;
    };

    static changePinboardsPage(page: number): Promise<void> {
        let promise = new Promise<void>((resolve) => {
            FilterGroup.currentPage = page;
            FilterGroup.filters.previousPage = page;
            FilterGroup.pinboards = [];

            if (!FiltersWidget.designer) {
                resolve();
                return;
            }

            AssetManagerServices.getPinboards(FilterGroup.filters.public_pinboards, FiltersWidget.designer.mail, FilterGroup.currentPage, 20, function (result: any) {
                if (result['totalRows'] && result['resources']) {
                    FilterGroup.pagination = FilterGroup.generatePagination(result['totalRows'], 20, FilterGroup.currentPage);
                    FilterGroup.pinboards = result['resources'];
                } else {
                    FilterGroup.pagination = null;
                    FilterGroup.pinboards = [];
                }
                resolve();
                setTimeout(function () {
                    FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                    Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                }, 50);
            });
        });

        return promise;
    };

    static changeProjectPage(page: number): Promise<void> {
        let promise = new Promise<void>((resolve) => {
            FilterGroup.currentPage = page;
            FilterGroup.filters.previousPage = page;
            var roomTypes = [];
            for (var i = 0; FilterGroup.filters.roomType && i < FilterGroup.filters.roomType.length; ++i) {
                roomTypes.push(FilterGroup.filters.roomType[i]._id);
            }

            //if (user.platforms_id !== 1) {
            var styles = [];
            for (var i = 0; FilterGroup.filters.style && i < FilterGroup.filters.style.length; ++i) {
                styles.push(FilterGroup.filters.style[i]._id);
            }
            AssetManagerServices.getTemplates(styles, roomTypes, '&fields=name,_id&sort=name', FilterGroup.currentPage, 40, function (result: any) {
                if (result) {
                    FilterGroup.pagination = FilterGroup.generatePagination(result.totalRows, 40, FilterGroup.currentPage);
                } else {
                    FilterGroup.pagination = null;
                }
                FilterGroup.projectResults = result.resources;
                resolve();
                setTimeout(function () {
                    FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                    Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                }, 50);
            });
        });

        return promise;
    }

    static isTemplateSelected(template) {
        if (FilterGroup.selectedTemplate && FilterGroup.selectedTemplate._id === template._id) {
            return ('vertical-align: middle;font-weight: bold;text-decoration-line: underline;color:#E0D000');
        }
        return ('vertical-align: middle');
    };

    static isPinboardSelected(pinboard) {
        if (FilterGroup.selectedPinboardId && FilterGroup.selectedPinboardId === pinboard._id) {
            return ('vertical-align: middle;font-weight: bold;text-decoration-line: underline;color:#E0D000');
        }
        return ('vertical-align: middle');
    };

    static isGroupSelected(group) {
        if (FilterGroup.selectedGroupdId && FilterGroup.selectedGroupdId === group._id) {
            return ('vertical-align: middle;font-weight: bold;text-decoration-line: underline;color:#E0D000');
        }
        return ('vertical-align: middle');
    };

    static replaceWithCurrentAssets() {
        if (!FilterGroup.filters.assets || FilterGroup.filters.assets.length === 0) {
            return;
        }
        let stringFilters = FiltersWidget.currentFiltersGroup.generateStringFilter();
        AssetManagerServices.getAssets("assets", stringFilters, function (result: any) {
            if (result.status === 200) {
                Savane.eventsManager.instance.dispatch(Savane.Events.REPLACE_SELECTED_ARRANGEMENTS_WITH_SHOPPING_LIST, result.data.resources);
            }
        });
    }

    static ListenerEntry: {
        "call": () => void
        "temporary": boolean
    };
    static selectedEntitiesListeners: (typeof this.ListenerEntry)[] = [];
    static addEntitySelectionListener(listener: () => void, temporary: boolean = false) {
        let listenerMethods = this.selectedEntitiesListeners.map(entry => entry.call);
        if (listenerMethods.includes(listener)) return;
        FilterGroup.selectedEntitiesListeners.push({
            call: listener,
            temporary: temporary
        });
    }

    static removeEntitySelectionListener(listener: () => void) {
        FilterGroup.selectedEntitiesListeners = FilterGroup.selectedEntitiesListeners.filter((l) => listener !== l.call);
    }

    static cachedSelectedEntities: any[] = [];
    static selectedEntitiesWatcher: NodeJS.Timeout | null = null;
    static startSelectionWatcher() {
        if (FilterGroup.selectedEntitiesWatcher) return;
        FilterGroup.selectedEntitiesWatcher = setInterval(() => {
            let newVal: any[] = PlanManager.getInstance().selectedEntities;
            let oldVal: any[] = FilterGroup.cachedSelectedEntities;

            let changed = newVal.length !== oldVal.length;
            if (!changed) {
                changed = newVal.some((item) => {
                    return !oldVal.includes(item);
                });
            }

            if (changed) {
                FilterGroup.cachedSelectedEntities = newVal;
                FilterGroup.selectedEntitiesListeners.forEach(entry => entry.call());
                FilterGroup.selectedEntitiesListeners = FilterGroup.selectedEntitiesListeners.filter(entry => {
                    return !entry.temporary;
                });
            }
        }, 50);
    }

    static removeFreeCameraFromRhinovFormat(camera: any) {
        new Savane.Commands.DeleteEntityCommand(camera).execute();
        Savane.EntityFactory.setLastEntityId(Savane.EntityFactory.getLastEntityId() - 1);
    };

    static addFreeCameraToRhinovFormat() {
        let camera = Savane.EntityFactory.createEmptyRenderCamera();

        let matrix = Savane.math.mat4.create();
        let array = [];
        FilterGroup.freeCamera.matrix.toArray(array);
        Savane.math.mat4.set(matrix,
            array[0], array[1], array[2], array[3],
            -array[8], -array[9], -array[10], array[11],
            array[4], array[5], array[6], array[7],
            array[12] * 100, array[13] * 100, array[14] * 100, array[15]);
        camera.transform.localMatrix = matrix;
        let parent = PlanManager.getInstance().world.currentScene.getFloorAtPosition(camera.position)
        if (parent.height + parent.getFloorMaxRoomHeight() < camera.height) {
            camera._cameraType = Savane.SceneConstants.CameraType.Axonomic;
        }
        new Savane.Commands.AddEntityCommand(camera, parent, true).execute();
        camera.updateCameraNb(PlanManager.getInstance().world);

        return (camera);
    };

    static requestOnePreview(guid: any) {
        switch (FilterGroup.previewCameraId) {
            // No valid camera selected
            case -2:
                Savane.eventsManager.instance.dispatch(Savane.Events.RENDER_ALL, { preview: true, guid: guid });
                break;

            // Free camera selected
            case -1:
                let freeCamera = FilterGroup.addFreeCameraToRhinovFormat();
                Savane.eventsManager.instance.dispatch("launchRender", { camera_id: freeCamera.id, preview: true, guid: guid });
                FilterGroup.removeFreeCameraFromRhinovFormat(freeCamera);
                break;

            // Other camera selected
            default:
                Savane.eventsManager.instance.dispatch("launchRender", { camera_id: FilterGroup.previewCameraId, preview: true, guid: guid });
        }
    };

    static startStopPreviewAuto() {
        if (FilterGroup.previewAuto) {
            FilterGroup.previewAuto = false;
            clearInterval(FilterGroup.previewAutoIntervalId);
            if (FilterGroup.previewAutoWindow && !FilterGroup.previewAutoWindow.closed) {
                FilterGroup.previewAutoWindow.close();
            }
        }
        else {
            FilterGroup.previewAuto = true;

            FilterGroup.guidForPreview = FiltersWidget.$routeParams.deliverableId;

            if (!FilterGroup.guidForPreview) {
                FilterGroup.guidForPreview = new Date().getTime() % 0x7FFFFFFF;
            }
            let uri = (typeof HP_CONFIG !== 'undefined') ? HP_CONFIG.PLANNERUri : 'https://hp.rhinov.fr/';
            let url = uri + '#/preview/' + FilterGroup.guidForPreview;
            // Open URL with time stamp to listen to this preview request
            if (FiltersWidget.openPreviewFunc) {
                FiltersWidget.openPreviewFunc(url);
            }
            else {
                FilterGroup.previewAutoWindow = window.open(url);
            }
            FilterGroup.requestOnePreview(FilterGroup.guidForPreview);
            FilterGroup.previewAutoIntervalId = setInterval(FilterGroup.requestOnePreview, 60 * 1000, FilterGroup.guidForPreview);
        }
    };

    static getColumParam(nbColums: number) {
        switch (nbColums) {
            case 2:
                return ('col-sm-6');
            case 4:
                return ('col-sm-3');
            case 0:
                return ('');
        }
    };

    static getMinPrice() {
        return '' + FilterGroup.filters.minPrice;
    };

    static getMaxPrice() {
        return '' + FilterGroup.filters.maxPrice;
    };

    static getMinWidth() {
        return '' + FilterGroup.filters.minWidth;
    };

    static getMaxWidth() {
        return '' + FilterGroup.filters.maxWidth;
    };

    static collectCustomizableEntities(items: any[]): any[] {
        let result: any[] = [];
        let instance = PlanManager.getInstance();
        if (!instance) {
            return result;
        }

        result = result.concat(items.filter(function (item) {
            if (!item.customization) {
                return (false);
            }
            return (item.customization.parts.length > 0);
        }));

        for (let i = 0; i < items.length; ++i) {
            result = result.concat(FilterGroup.collectCustomizableEntities(items[i].children));
        }

        return result;
    }

    static selectedArrangementsHas(part) {
        let instance = PlanManager.getInstance();
        if (!instance) {
            return false;
        }

        let selectedEntities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);

        if (selectedEntities.length === 0) {
            return true;
        }

        for (let i = 0; i < selectedEntities.length; i++) {
            let item = selectedEntities[i];

            if (item.isArrangementObjectEntity()) {
                if (item.customization.parts) {
                    for (let j = 0; j < item.customization.parts.length; j++) {
                        if (item.customization.parts[j].name.includes(part)) {
                            return (true);
                        }
                    }
                }
            }
        }

        return (false);
    }

    static updateArrangementCoating(coating: any, customName: string, objectTypeList: any[]) {
        let instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        let entities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);
        if (entities.length === 0) {
            entities = FilterGroup.collectCustomizableEntities(instance.world.currentScene.currentFloor.iArrangements);
        }

        let defaultAssigned = false;
        for (let i = 0; i < entities.length; i++) {
            EntityDefaultPropertiesManager.getInstance().setDefaultCoating(customName, coating._id, entities[i].manufacturer.name, entities[i].objectType);
            defaultAssigned = true;
        }
        if (!defaultAssigned) {
            EntityDefaultPropertiesManager.getInstance().setDefaultCoating(customName, coating._id, coating.manufacturer.name);
        }

        if (customName === "Porte") {
            EntityDefaultPropertiesManager.getInstance().setDoorCustomizationGroups(coating.customizationGroups);
        }
        // TODO warning here 2 parameters removed because not necessary anymore
        instance.executeCommand(new Savane.Commands.ChangeKitchenCoatingCommand(entities, coating, customName, objectTypeList));
    };

    static applyHandleModeleType(item: any) {
        let promise = new Promise<void>((resolve, reject) => {
            if (EntityDefaultPropertiesManager.getInstance().kitchenDefaultHandle === '') {
                resolve();
                return;
            }

            AssetManagerServices.getAsset(AssetManagerServices._ASSET_TYPE.ARRANGEMENTS, EntityDefaultPropertiesManager.getInstance().getDefaultHandle(item.manufacturer.name, item.objectType), null, function (handleAsset: any) {
                let handleModele = handleAsset;
                if (handleModele !== null) {
                    AssetManagerServices.createAssetEntity(AssetManagerServices._ASSET_TYPE.ARRANGEMENTS, handleModele, true, function (handleEntity: any) {
                        // We do as if we delete the current object
                        Savane.eventsManager.instance.dispatch(Savane.Events.COMMAND_EXECUTED,
                            {
                                name: Savane.Commands.CommandEnum.DeleteEntityCommand,
                                undo: false,
                                datas: {
                                    id: item.id,
                                    type: item.entityType,
                                    entity: item
                                }
                            });

                        // Populate the arrangement with the handle
                        item.populateWithHandles(handleEntity, item.handleSide);

                        // Inform WebGL to update this object by adding it back to the scene
                        Savane.eventsManager.instance.dispatch(Savane.Events.COMMAND_EXECUTED,
                            {
                                name: Savane.Commands.CommandEnum.AddEntityCommand,
                                undo: false,
                                datas: {
                                    id: item.id,
                                    type: item.entityType,
                                    entity: item
                                }
                            });

                        PlanManager.getInstance().saveInCache();
                        resolve();
                    });
                } else resolve();
            });
        });

        return promise;
    }

    static isHandleUsed(modele: any, objectTypeList: any[]) {
        let instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        if (FilterGroup.cache.name !== 'Handles') {
            FilterGroup.cache.name = 'Handles';
            FilterGroup.cache.list = [];

            let entities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);
            if (entities.length === 0) {
                entities = FilterGroup.collectCustomizableEntities(instance.world.currentScene.currentFloor.iArrangements);
            }

            for (let i = 0; i < entities.length; ++i) {
                let item = entities[i];

                if (objectTypeList.indexOf(item.objectType) === -1) {
                    continue;
                }
                if (FilterGroup.cache.list.indexOf(item.getHandleAsset()) === -1) {
                    FilterGroup.cache.list.push(item.getHandleAsset());
                }
            }
        }

        return (FilterGroup.cache.list.indexOf(modele._id) !== -1);
    };

    static updateArrangementHandleModeleType(modele: any, objectTypeList: any[]): Promise<void[]> {
        let instance = PlanManager.getInstance();
        if (!instance) {
            return undefined;
        }

        let entities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);
        if (entities.length === 0) {
            entities = FilterGroup.collectCustomizableEntities(instance.world.currentScene.currentFloor.iArrangements);
        }

        // Set default arrangement handle types
        let defaultAssigned = false;
        for (var i = 0; i < entities.length; i++) {
            EntityDefaultPropertiesManager.getInstance().setDefaultHandle(modele._id, entities[i].manufacturer.name, entities[i].objectType);
            defaultAssigned = true;
        }
        if (!defaultAssigned) {
            EntityDefaultPropertiesManager.getInstance().setDefaultHandle(modele._id, modele.manufacturer.name, entities[i].objectType);
        }
        PlanManager.getInstance().saveInCache();

        let handlePromises: Promise<void>[] = [];
        for (let i = 0; i < entities.length; ++i) {
            let item = entities[i];

            if (objectTypeList.indexOf(item.objectType) === -1) {
                continue;
            }

            handlePromises.push(FilterGroup.applyHandleModeleType(item));
        }
        return Promise.all(handlePromises);
    };

    static removeArrangementHandleModel(objectTypeList: any[]) {
        let instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        let entities = instance.selectedEntities.filter(function (item: any) {
            return !!item.customization && item.customization.parts.length > 0;
        });

        if (entities.length === 0) {
            entities = instance.world.currentScene.currentFloor.iArrangements.filter(function (item: any) {
                return !!item.customization && item.customization.parts.length > 0;
            });
        }

        for (let i = 0; i < entities.length; ++i) {
            const item = entities[i];

            if (objectTypeList.indexOf(item.objectType) === -1) {
                continue;
            }

            EntityDefaultPropertiesManager.getInstance().setDefaultHandle('', item.manufacturer.name, item.objectType);
            item.handleAsset = '';

            // We do as if we delete the current object
            Savane.eventsManager.instance.dispatch(Savane.Events.COMMAND_EXECUTED, {
                name: Savane.Commands.CommandEnum.DeleteEntityCommand,
                undo: false,
                datas: {
                    id: item.id,
                    type: item.entityType,
                    entity: item
                }
            });

            // Clear current object from any handle
            item.clearAllHandles(item.handleSide);

            // Inform WebGL to update this object by adding it back to the scene
            Savane.eventsManager.instance.dispatch(Savane.Events.COMMAND_EXECUTED, {
                name: Savane.Commands.CommandEnum.AddEntityCommand,
                undo: false,
                datas: {
                    id: item.id,
                    type: item.entityType,
                    entity: item
                }
            });
        }
        PlanManager.getInstance().saveInCache();
    };

    static operator(operator: string) {
        switch (operator) {
            case 'lesserThan':
                return 'le';
            case 'greaterThan':
                return 'ge';
            case 'equal':
                return 'eq';
            case 'in':
                return 'in';
            case 'notIn':
                return 'nin';
        }
    };

    /**
     * RECURSIVE
     *
     * @param objectType
     * @param res
     * @private
     */
    static _extractObjectType(objectType: any, res: any[]) {
        if (objectType.children.length <= 0) {
            let id = objectType._id;
            if (res.indexOf(id) < 0) {
                //End
                res.push(id);
            }
        }
        else {
            for (let i = 0; i < objectType.children.length; i++) {
                FilterGroup._extractObjectType(objectType.children[i], res);
            }
        }
    };

    static recurSearchObjectType(type: string, objectTypesTree: any[]) {
        if (objectTypesTree) {
            for (let i = 0; i < objectTypesTree.length; i++) {
                if (objectTypesTree[i]._id === type) {
                    return (objectTypesTree[i]);
                }

                let objectType = FilterGroup.recurSearchObjectType(type, objectTypesTree[i].children);
                if (objectType !== null) {
                    return (objectType);
                }
            }
        }

        return (null);
    };

    static recurSearchObjectTypeByName(name: string, objectTypesTree: any[]) {
        if (objectTypesTree) {
            for (let i = 0; i < objectTypesTree.length; i++) {
                if (objectTypesTree[i].vocals.keywords) {
                    for (let j = 0; j < objectTypesTree[i].vocals.keywords.length; j++) {
                        if (objectTypesTree[i].vocals.keywords[j].toLowerCase() === name) {
                            return (objectTypesTree[i]);
                        }
                    }

                    let objectType = FilterGroup.recurSearchObjectTypeByName(name, objectTypesTree[i].children);
                    if (objectType !== null) {
                        return (objectType);
                    }
                }
            }
        }

        return (null);
    };

    /**
     * Generates every global part on the string filter. (super.generateStringFilter)
     * 
     * Should be implemented by every class extending this one (ie. XFilterWidget).
     * 
     * To implement it, copy `generateStringFilterTemplate` and rename it `generateStringFilter`.
     */
    generateStringFilter(): string {
        var i: number;
        let stringFilters = '';
        if (!FiltersWidget.currentFiltersGroup) return '';

        if (FilterGroup.filters.coatingType !== null && FilterGroup.filters.coatingType.length > 0) {
            stringFilters += '&q.coatingType.in='; //TODO: check if this is correct
            for (i = 0; i < FilterGroup.filters.coatingType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += FilterGroup.filters.coatingType[i]._id;
            }
        }

        if (FilterGroup.filters.joineryType !== null && FilterGroup.filters.joineryType.length > 0) {
            stringFilters += '&q.joineryType.in='; //TODO: check if this is correct
            for (i = 0; i < FilterGroup.filters.joineryType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += FilterGroup.filters.joineryType[i]._id;
            }
        }

        if (FilterGroup.filters.technicalElementType !== null && FilterGroup.filters.technicalElementType.length > 0) {
            stringFilters += '&q.technicalElementType.in='; //TODO: check if this is correct
            for (i = 0; i < FilterGroup.filters.technicalElementType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += FilterGroup.filters.technicalElementType[i]._id;
            }
        }

        //Update object type
        let newObjectsTypes: any[] = [];

        if (FilterGroup.filters.objectType !== null && FilterGroup.filters.objectType.length > 0) {
            let res: any[] = [];

            for (i = 0; i < FilterGroup.filters.objectType.length; i++) {
                if (newObjectsTypes.length > 0) {
                    //Verify if each element is son of the previous one, if not stop the filter now
                    if (newObjectsTypes[newObjectsTypes.length - 1].children.indexOf(FilterGroup.filters.objectType[i]) < 0) {
                        break;
                    }
                }
                else {
                    if (FilterGroup.filters.objectType[i].parent.parent !== null) {
                        break; //First elem is not a root, stop now
                    }
                }

                newObjectsTypes.push(FilterGroup.filters.objectType[i]);
                //FilterGroup._extractObjectType(filters.objectType[i], res);
            }

            if (newObjectsTypes.length > 0) {
                FilterGroup._extractObjectType(newObjectsTypes[newObjectsTypes.length - 1], res);
                if (!FilterGroup.smartSearch()) {
                    stringFilters += '&q.objectType.in=' + newObjectsTypes[newObjectsTypes.length - 1]._id + ',';

                    for (i = 0; i < res.length; i++) {
                        if (i > 0) {
                            stringFilters += ',';
                        }
                        stringFilters += res[i];
                    }
                }
                FilterGroup.actualList = newObjectsTypes[newObjectsTypes.length - 1].children;
            }
            else {
                FilterGroup.actualList = FilterGroup.objectTypes;
            }
            //Replace with cleared filters
            FilterGroup.filters.objectType = newObjectsTypes;
        }
        else {
            FilterGroup.actualList = FilterGroup.objectTypes;
        }

        if (FilterGroup.filters.kitchenElement && FilterGroup.filters.kitchenElement.id) {
            switch (FilterGroup.filters.kitchenElement.type) {
                case 'ObjectType':
                    stringFilters += '&descending=objectType&q.objectType.in=' + FilterGroup.filters.kitchenElement.id;
                    break;
                case 'DoorType':
                    stringFilters += '&descending=objectType&q.objectTypeConfig.doorType.eq=' + FilterGroup.filters.kitchenElement.id + '&sort=name&q.objectType.in=5bc064b9efe98c5c27d0a801,5c34c0873614a6380e44ddeb';
                    break;
            }
        } else if (FiltersWidget.currentFiltersGroup.id === 'kitchen') {
            stringFilters += '&descending=objectType&q.objectType.in=5bc064b9efe98c5c27d0a801,5c34c0873614a6380e44ddeb';
        }

        if (FilterGroup.filters.bathroomElement && FilterGroup.filters.bathroomElement.id) {
            switch (FilterGroup.filters.bathroomElement.type) {
                case 'ObjectType':
                    stringFilters += '&descending=objectType&q.objectType.in=' + FilterGroup.filters.bathroomElement.id;
                    break;
                case 'CollectionType':
                    stringFilters += '&q.manufacturer_collection.eq=' + FilterGroup.filters.bathroomElement.id;
                    break;
            }
            if (FilterGroup.filters.bathroomElement.name.indexOf('Lapeyre Formeo') !== -1) {
                stringFilters += '&sort=objectType,dimensions.length,dimensions.height,dimensions.width';
            }
            else {
                if (FilterGroup.filters.bathroomElement.type === 'CollectionType') {
                    stringFilters += '&sort=name';
                }
            }
        }
        else if (FiltersWidget.currentFiltersGroup.id === 'bathroom') {
            stringFilters += '&descending=objectType&q.objectType.eq=5bc06cbebe6c755c1fb2d5e3';
        }

        if (FiltersWidget.currentFiltersGroup.id === 'storage') {
            stringFilters += '&descending=objectType&q.objectType.in=6708f801d52af3f7af79634a,678a70c30136b3444d1ba098,678fb503d6813787c5a29a1a&q.manufacturer.in=5eba5c37f3c97d07e6f83b5e&sort=dimensions.height'
            if (FilterGroup.filters.storageElementDepth && FilterGroup.filters.storageElementDepth.mindepth && FilterGroup.filters.storageElementDepth.maxdepth) {
                stringFilters += '&q.dimensions.length.bt=' + (FilterGroup.filters.storageElementDepth.mindepth) + ',' + (FilterGroup.filters.storageElementDepth.maxdepth);

                if (FilterGroup.filters.storageElementHeight && FilterGroup.filters.storageElementHeight.height !== 0) {
                    stringFilters += '&q.dimensions.height.bt=' + (FilterGroup.filters.storageElementHeight.height - 10) + ',' + (FilterGroup.filters.storageElementHeight.height + 10);
                }
                else {
                    stringFilters += '&q.dimensions.height.nin=2000,2045';
                }
            }
            else {
                if (FilterGroup.filters.storageElementDepth.type) {
                    stringFilters += '&q.dimensions.height.in=2000,2045';
                }
            }

            if (FilterGroup.filters.storageElementType && FilterGroup.filters.storageElementType.type !== null) {
                stringFilters += FilterGroup.filters.storageElementType.type;
            }
        }

        if (FilterGroup.filters.magicsearch) {
            stringFilters += '&filter=' + FilterGroup.filters.magicsearch;
        }

        return stringFilters;
    }

    /**
     *  @deprecated Do not call ! Call **generateStringFilter** instead !
     * 
     * This is the **template** that should copied by any class extending this one.
     * 
     * Check out `generateStringFilter` for more info. 
     */
    generateStringFilterTemplate() {
        var i: number;
        let stringFilters = '' //super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (FiltersWidget.currentFiltersGroup.id === 'coatings') {
            stringFilters += '&q.hang.cabinet.eq=false&q.hang.worktop.eq=false&q.hang.credence.eq=false';
        }

        if (FiltersWidget.currentFiltersGroup.id !== 'style') {
            if (filters.style !== null && filters.style.length > 0) {
                stringFilters += '&q.styles._id.in=';
                for (i = 0; i < filters.style.length; i++) {
                    if (i > 0) {
                        stringFilters += ',';
                    }
                    stringFilters += filters.style[i]._id;
                }
            }

            if (filters.roomType !== null && filters.roomType.length > 0) {
                stringFilters += '&q.environment.roomTypes.in=';
                for (i = 0; i < filters.roomType.length; i++) {
                    if (i > 0) {
                        stringFilters += ',';
                    }
                    stringFilters += filters.roomType[i]._id;
                }
            }
        }

        if (FiltersWidget.currentFiltersGroup.id !== 'groups') {
            if (Array.isArray(filters.name)) {
                if (filters.name.length > 0) {
                    if (FilterGroup.smartSearch()) {
                        if (FiltersWidget.currentFiltersGroup.id === 'assets') {
                            stringFilters += '&q.kind.eq=Arrangement'
                        }
                        if (FiltersWidget.currentFiltersGroup.id === 'coatings') {
                            stringFilters += '&q.kind.eq=Coating'
                        }
                        stringFilters += '&filter=' + filters.name.join(',');
                    }
                    else {
                        if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                            stringFilters += '&q.labels.lk=' + filters.name.join(',');
                        }
                        else {
                            stringFilters += '&text=' + filters.name.join(',');
                        }
                    }
                }
            }
            else if (filters.name) {
                if (FilterGroup.smartSearch()) {
                    if (FiltersWidget.currentFiltersGroup.id === 'assets') {
                        stringFilters += '&q.kind.eq=Arrangement'
                    }
                    if (FiltersWidget.currentFiltersGroup.id === 'coatings') {
                        stringFilters += '&q.kind.eq=Coating'
                    }
                    stringFilters += '&filter=' + filters.name;
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name;
                    }
                    else {
                        stringFilters += '&text=' + filters.name;
                    }
                }
            }
        }
        else {
            if (filters.name) {
                stringFilters += '&q.name.lk=' + filters.name;
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (FiltersWidget.currentFiltersGroup.id === 'groups') {
            sort.push('name');
        }

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        if (FiltersWidget.currentFiltersGroup.id === 'coatings') {
            stringFilters += '&sort=-isHpFloorGenerator,-created_at';
        }

        // We only want non kitchen fab objects
        if (FiltersWidget.currentFiltersGroup.id !== 'groups' && FiltersWidget.currentFiltersGroup.id !== "style" && !FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            if (FiltersWidget.currentFiltersGroup.id === 'magicsearch' && filters.showForGraphicArtists) {
                stringFilters += '&q.pipeline.unrealState.in=cooked,ready';
            }
            else {
                stringFilters += '&q.pipeline.unrealState.eq=ready';
            }
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;

            if (FiltersWidget.currentFiltersGroup.id === "style") {
                stringFilters += '&order=_id';
            }
        }
        return stringFilters;
    }

    static initSortArray(): { stringFilter: string, sort: any[] } {
        let sort: any[] = [];
        let stringFilters = '';
        if (FilterGroup.filters.useColorSearch) return { stringFilter: stringFilters, sort: sort };

        if (!FilterGroup.smartSearch()) {
            if (FilterGroup.filters.showUnavailable !== true) {
                if (FilterGroup.filters.showContentFactory === true) {
                    stringFilters += '&q.pipeline.state.in=available,archived';
                }
                else {
                    // only AVAILABLE display
                    //stringFilters += '&q.pipeline.state.eq=available';
                    // ARCHIVED + AVAILABLE display
                    stringFilters += '&q.pipeline.state.in=available,archived';
                }
            }
            else {
                if (FiltersWidget.currentFiltersGroup.id !== 'groups' && FiltersWidget.currentFiltersGroup.id !== 'style' && !FiltersWidget.getDecorationService().displayGroups) {
                    if (FilterGroup.filters.showContentFactory === true) {
                        stringFilters += '&q.pipeline.state.in=pending';
                    }
                    else {
                        stringFilters += '&q.pipeline.state.in=available,archived,terminated';
                    }
                }
            }

            if (FilterGroup.filters.showRSE === true) {
                stringFilters += '&q.rse.eq=true';
            }
            if (FilterGroup.filters.showContentFactory === true) {
                stringFilters += '&q.pipeline.quality.eq=high';
            }
            if (FilterGroup.filters.showNewObjects === true) {
                let now = new Date();
                now.setMonth(now.getMonth() - 3);
                stringFilters += '&q.pipeline.validationDate.gt=' + now.toISOString();
            }

            switch (FilterGroup.filters.showPriority) {
                case 'MDM':
                    stringFilters += '&q.manufacturer.in=579b5fc0d7ee59f805e3c065';
                    if (FilterGroup.filters.showUnavailable !== true && FilterGroup.filters.showContentFactory !== true) {
                        stringFilters += AssetManagerServices.ARRMGR_COUNTRY_PARAM;
                    }
                    break;
                case 'MKP_MDM':
                    stringFilters += '&q.retailer.in=579b5fc0d7ee59f805e3c065';
                    if (FilterGroup.filters.showUnavailable !== true && FilterGroup.filters.showContentFactory !== true) {
                        stringFilters += AssetManagerServices.ARRMGR_COUNTRY_PARAM;
                    }
                    break;
                case 'REFERENCED':
                    stringFilters += '&q.manufacturer.nin=5dc1444db70bd31e474747de,5be2c40c2e50ee46876e546d';
                    // if (FilterGroup.filters.showUnavailable !== true && FiltersWidget.currentFiltersGroup.id !== 'coatings') {
                    //     stringFilters += AssetManagerServices.ARRMGR_COUNTRY_PARAM;
                    // }
                    break;
                case 'CLIENT':
                    stringFilters += '&q.manufacturer.in=5dc1444db70bd31e474747de';
                    break;
                case 'GENERIC':
                    stringFilters += '&q.manufacturer.in=5be2c40c2e50ee46876e546d&descending=objectType&q.objectType.nin=5bc064b9efe98c5c27d0a801,5c34c0873614a6380e44ddeb,5bc06cbebe6c755c1fb2d5e3,5bc06c1fd08ceb5c26f750c9,5f915356d651782a0ec38941,5bc06b51b130575c39f762ab,5cc035899de2486cda32775c';
                    break;
                case 'PLACEHOLDERS':
                    stringFilters += '&q.manufacturer.in=5df89bb3c5b06666d1a38703';
                    break;
            }

            switch (FilterGroup.filters.hang) {
                case 'WALL':
                    stringFilters += '&q.hang.wall.eq=true';
                    break;
                case 'FLOOR':
                    stringFilters += '&q.hang.floor.eq=true';
                    break;
                case 'CEILING':
                    stringFilters += '&q.hang.ceiling.eq=true';
                    break;
            }


            if (FilterGroup.filters.universes) {
                let oneAdded = false;

                // START
                if (FilterGroup.filters.universes.indoor || FilterGroup.filters.universes.bathroom || FilterGroup.filters.universes.outdoor || FilterGroup.filters.universes.junior) {
                    stringFilters += '&or=';
                }
                if (FilterGroup.filters.universes.indoor) {
                    stringFilters += 'q.universes.indoor.eq=' + FilterGroup.filters.universes.indoor;
                    oneAdded = true;
                }
                if (FilterGroup.filters.universes.bathroom) {
                    if (oneAdded) {
                        stringFilters += ';';
                    }
                    stringFilters += 'q.universes.bathroom.eq=' + FilterGroup.filters.universes.bathroom;
                    oneAdded = true;
                }
                if (FilterGroup.filters.universes.outdoor) {
                    if (oneAdded) {
                        stringFilters += ';';
                    }
                    stringFilters += 'q.universes.outdoor.eq=' + FilterGroup.filters.universes.outdoor;
                    oneAdded = true;
                }
                if (FilterGroup.filters.universes.junior) {
                    if (oneAdded) {
                        stringFilters += ';';
                    }
                    stringFilters += 'q.universes.junior.eq=' + FilterGroup.filters.universes.junior;
                }

                if (!FilterGroup.filters.universes.indoor && !FilterGroup.filters.universes.bathroom && !FilterGroup.filters.universes.outdoor && !FilterGroup.filters.universes.junior && FilterGroup.filters.showPriority === 'PLACEHOLDERS') {
                    sort.push('-universes.indoor');
                    sort.push('-universes.bathroom');
                    sort.push('-universes.outdoor');
                    sort.push('-universes.junior');
                }
                if (FilterGroup.filters.universes.B2B === true) {
                    stringFilters += '&q.universes.B2B.eq=true';
                } else {
                    stringFilters += '&q.universes.B2C.eq=true';
                }
                // END

                if (FilterGroup.filters.showContentFactory !== true && FilterGroup.filters.showPriority !== 'CLIENT' && FilterGroup.filters.showPriority !== 'GENERIC' && FilterGroup.filters.showPriority !== 'PLACEHOLDERS') {
                    if (![NaN, undefined].includes(FilterGroup.filters.minPrice) && FilterGroup.filters.minPrice > 0) {
                        stringFilters += '&q.price.value.gt=' + FilterGroup.filters.minPrice;
                    }

                    if (![NaN, undefined].includes(FilterGroup.filters.maxPrice)) {
                        stringFilters += '&q.price.value.lt=' + FilterGroup.filters.maxPrice;
                    }
                }

                if (ObjectTypeFilter.objectFilters() && ObjectTypeFilter.objectFiltersBySize()) {
                    if (FilterGroup.savedEntity) {
                        stringFilters += '&q.dimensions.width.bt=' + (FilterGroup.savedEntity.length - (FilterGroup.savedEntity.length * 0.05)) + ',' + (FilterGroup.savedEntity.length + (FilterGroup.savedEntity.length * 0.05));
                        if (FilterGroup.savedEntity.anchor[1] < 0) {
                            stringFilters += '&q.dimensions.height.bt=' + (FilterGroup.savedEntity.height - (FilterGroup.savedEntity.height * 0.05)) + ',' + (FilterGroup.savedEntity.height + (FilterGroup.savedEntity.height * 0.05));
                        } else {
                            stringFilters += '&q.dimensions.length.bt=' + (FilterGroup.savedEntity.width - (FilterGroup.savedEntity.width * 0.05)) + ',' + (FilterGroup.savedEntity.width + (FilterGroup.savedEntity.width * 0.05));
                        }
                    }
                }
                else {
                    if (![NaN, undefined].includes(FilterGroup.filters.minWidth) && ![NaN, undefined].includes(FilterGroup.filters.maxWidth)) {
                        stringFilters += '&q.dimensions.width.bt=' + FilterGroup.filters.minWidth + ',' + FilterGroup.filters.maxWidth;
                    }
                }

                if (FilterGroup.filters.sort && FilterGroup.filters.sort.width) {
                    if (FilterGroup.filters.sort.width === 1) {
                        sort.push('dimensions.width');
                    } else {
                        sort.push('-dimensions.width');
                    }
                }

                if (FilterGroup.filters.sort && FilterGroup.filters.sort.price) {
                    if (FilterGroup.filters.sort.price === 1) {
                        sort.push('price.value');
                    } else {
                        sort.push('-price.value');
                    }
                }
            }
        }
        else {
            if ((FilterGroup.filters.showUnavailable === true) && (FilterGroup.filters.showContentFactory === true)) {
                stringFilters += '&q.pipeline.state.in=pending&q.pipeline.quality.eq=high';
            }
            else {
                if (FilterGroup.filters.showContentFactory === true) {
                    stringFilters += '&q.pipeline.state.in=available,archived&q.pipeline.quality.eq=high';
                }
                else {
                    stringFilters += '&q.pipeline.state.in=available,archived,terminated';
                }
            }
        }

        return {
            stringFilter: stringFilters,
            sort: sort
        };
    }

    static smartSearch() {
        if (!FiltersWidget.currentFiltersGroup) return false;
        if (FiltersWidget.currentFiltersGroup.id !== 'assets' && FiltersWidget.currentFiltersGroup.id !== 'coatings') {
            return (false);
        }
        return (FilterGroup.smartSearchActivated === 1);
    };

    /**
     * Retrieve list of styles from asset manager
     * TODO Move that into the shared service of the module
     */
    static loadStyles() {
        let ret = new Promise<void>((resolve, reject) => {
            if (FilterGroup.styles !== null && FilterGroup.styles !== undefined) {
                resolve();
                return;
            }
            fetch(AssetManagerServices.getUrl() + 'api/v1/templates?sort=-count&fields=count&groupBy=styles&apikey=' + AssetManagerServices.getToken()).then((res) => {
                if (res.status === 200) {
                    res.json().then((data) => {
                        FilterGroup.styles = [];
                        for (let i = 0; i < data.resources.length; ++i) {
                            let resource = data.resources[i];
                            for (let j = 0; j < resource.group.length; ++j) {
                                FilterGroup.styles.push(resource.group[j]);
                            }
                        }
                        resolve();
                    })
                } else {
                    reject(res.statusText);
                }
            }).catch((err) => {
                console.error('Error loading styles:', err);
                reject(err);
            });
        });
        return ret;
    };

    static loadBOStyles(callback: Function) {
        if (FilterGroup.boStyles === null) {
            let uri = (typeof HP_CONFIG !== 'undefined') ? HP_CONFIG.APIUri : '//api.rhinovplanner.com/';
            fetch(uri + "api/v1.99/inspirations?q.inspirations.inspiration_family_id.in=23,24&limit=1000").then(res => {
                if (res.status === 200) {
                    res.json().then(data => {
                        FilterGroup.boStyles = data.resources;
                        if (callback) {
                            callback();
                        }
                    })
                }
            })
        }
    };

    static loadBORoomTypes(callback: Function) {
        if (FilterGroup.boRoomTypes === null) {
            let uri = (typeof HP_CONFIG !== 'undefined') ? HP_CONFIG.APIUri : '//api.rhinovplanner.com/';
            fetch(uri + "api/room_features?q.isPrimary.eq=1&sort=name&visibleHomePlanner=true").then(function (res) {
                if (res.status === 200) {
                    res.json().then(data => {
                        FilterGroup.boRoomTypes = data;
                        if (callback) {
                            callback();
                        }
                    })
                }
            })
        }
    };

    /**
         * Retrieve the list of room types
         * TODO Move that into the shared service of the module
         */
    static loadRoomTypes() {
        let ret = new Promise<void>((resolve, reject) => {
            if (FilterGroup.roomTypes !== null && FilterGroup.roomTypes !== undefined) {
                resolve();
                return;
            }
            fetch(AssetManagerServices.getUrl() + 'api/v1/roomTypes?q.forTemplates.eq=true&apikey=' + AssetManagerServices.getToken())
                .then(function (res) {
                    if (res.status === 200) {
                        res.json().then(data => {
                            // Clean filters
                            FilterGroup.filters.roomType = null;
                            // Set datas
                            FilterGroup.roomTypes = data.resources;
                            resolve();
                        })
                    } else {
                        reject(res.statusText);
                    }
                }).catch((err) => {
                    console.error('Error loading room types:', err);
                    reject(err);
                });
        });
        return ret;

    };

    /**
                 * Retrieve the list of coating types
                 * TODO Move that into the shared service of the module
                 */
    static loadCoatingTypes() {
        let ret = new Promise<void>((resolve, reject) => {
            if (FilterGroup.coatingTypes !== null && FilterGroup.coatingTypes !== undefined) {
                resolve();
            }

            fetch(AssetManagerServices.getUrl() + 'api/v1/coatingTypes?apikey=' + AssetManagerServices.getToken())
                .then(function (res) {
                    if (res.status === 200) {
                        res.json().then(data => {
                            // Clean filters
                            FilterGroup.filters.coatingType = null;
                            // Set datas
                            FilterGroup.coatingTypes = data.resources;
                            resolve();
                        })
                    }
                })
                .catch((err) => {
                    console.error('Error loading coating types:', err);
                    reject(err);
                });
        });

        return ret


    };

    /**
     * 
     * Retrieve the list of SVG brush for frontViewCoating areas
     */
    static loadSVGs() {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.SVGs !== null && FilterGroup.SVGs !== undefined) {
                resolve();
                return;
            }

            fetch(AssetManagerServices.getUrl() + 'api/v1/svgs?apikey=' + AssetManagerServices.getToken())
                .then(function (res) {
                    if (res.status === 200) {
                        res.json().then(data => {
                            // Clean filters
                            FilterGroup.filters.svg = null;
                            // Set datas
                            FilterGroup.SVGs = data.resources;
                            resolve();
                        })
                    } else {
                        reject(res.statusText);
                    }
                });
        });

        return promise;
    };

    /**
     * Retrieve the list of joinery types
     * TODO Move that into the shared service of the module
     * TODO use this method (see loadRoomTypes usage)
     */
    static loadJoineryTypes() {
        let ret = new Promise<void>((resolve, reject) => {
            if (FilterGroup.joineryTypes !== null && FilterGroup.joineryTypes !== undefined) {
                resolve();
                return;
            }
            fetch(AssetManagerServices.getUrl() + 'api/v1/joineryTypes?apikey=' + AssetManagerServices.getToken())
                .then(function (res) {
                    if (res.status === 200) {
                        res.json().then(data => {
                            //Clean filters
                            FilterGroup.filters.joineryType = null;
                            //Set datas
                            FilterGroup.joineryTypes = data.resources;
                        })
                    } else {
                        reject(res.statusText);
                    }
                }).catch((err) => {
                    console.error('Error loading Joinery types:', err);
                    reject(err);
                });
        });
        return ret;
    };

    /**
     * Retrieve the list of technical element types
     * TODO Move that into the shared service of the module
     * TODO use this method (see loadRoomTypes usage)
     */
    static loadTechnicalElementTypes() {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.technicalElementTypes !== null && FilterGroup.technicalElementTypes !== undefined) {
                resolve();
                return;
            }

            fetch(AssetManagerServices.getUrl() + 'api/v1/technicalElementTypes?apikey=' + AssetManagerServices.getToken())
                .then(function (res) {
                    if (res.status === 200) {
                        res.json().then(data => {
                            //Clean filters
                            FilterGroup.filters.technicalElementType = null;
                            //Set datas
                            FilterGroup.technicalElementTypes = data.resources;
                            resolve();
                        })
                    } else {
                        reject(res.statusText);
                    }
                });
        });

        return promise;
    };

    /**
     * Retrieve the list of objecttypes
     * TODO Move that into the shared service of the module
     */
    static loadObjectTypes() {
        let ret = new Promise<void>((resolve, reject) => {
            if (FilterGroup.objectTypes !== null && FilterGroup.objectTypes !== undefined) {
                resolve();
                return;
            }
            FilterGroup.actualList = null;
            fetch(AssetManagerServices.getUrl() + 'api/v1/objectTypes?apikey=' + AssetManagerServices.getToken() + '&q.parent.eq=null&children=1')
                .then(function (res) {
                    if (res.status === 200) {
                        res.json().then(data => {
                            FilterGroup.objectTypes = [];
                            let parentTypes = data.resources;
                            for (let i = 0; i < parentTypes.length; i++) {
                                for (let j = 0; j < parentTypes[i].children.length; j++) {
                                    FilterGroup.objectTypes.push(parentTypes[i].children[j]);
                                }
                            }
                            FilterGroup.actualList = FilterGroup.objectTypes;
                            resolve();
                        })
                    } else {
                        reject(res.statusText);
                    }
                }).catch((err) => {
                    console.error('Error loading object types:', err);
                    reject(err);
                });

        });

        return ret;
    };

    /**
     * Load the default filters set by user
     */
    static loadDefaultConfig() {
        let i: number, j: number, rType: any;

        if (FilterGroup.defaultFilters === undefined || FilterGroup.defaultFilters === null) {
            return; //No default configs set
        }
        if (!FiltersWidget.currentFiltersGroup) return;
        let defaultConfigGroup = FilterGroup.defaultFilters[FiltersWidget.currentFiltersGroup.id];
        if (defaultConfigGroup && defaultConfigGroup !== null) {
            //Load default roomType
            if (defaultConfigGroup.roomTypes && defaultConfigGroup.roomTypes !== null) {
                for (i = 0; i < defaultConfigGroup.roomTypes.length; i++) {
                    rType = defaultConfigGroup.roomTypes[i];

                    if (FilterGroup.roomTypes !== null) {
                        for (j = 0; j < FilterGroup.roomTypes.length; j++) {
                            if (FilterGroup.roomTypes[j]._id === rType) {
                                if (FilterGroup.filters.roomType === null) {
                                    FilterGroup.filters.roomType = [];
                                }
                                if (FilterGroup.filters.roomType.indexOf(FilterGroup.roomTypes[j]) < 0) {
                                    FilterGroup.filters.roomType.push(FilterGroup.roomTypes[j]);
                                }
                                break;
                            }
                        }
                    }
                }
            }

            // Load default objectType
            if (defaultConfigGroup.objectTypes && defaultConfigGroup.objectTypes !== null) {
                FilterGroup.filters.objectType = null;
                for (i = 0; i < defaultConfigGroup.objectTypes.length; i++) {
                    rType = defaultConfigGroup.objectTypes[i];
                    for (j = 0; j < FilterGroup.objectTypes.length; j++) {
                        if (FilterGroup.objectTypes[j]._id === rType) {
                            if (FilterGroup.filters.objectType === null) {
                                FilterGroup.filters.objectType = [];
                            }
                            if (FilterGroup.filters.objectType.indexOf(FilterGroup.objectTypes[j]) < 0) {
                                FilterGroup.filters.objectType.push(FilterGroup.objectTypes[j]);
                            }
                            break;
                        }
                    }
                }
            }

            // Load default coatingType
            if (defaultConfigGroup.coatingTypes && defaultConfigGroup.coatingTypes !== null) {
                FilterGroup.filters.coatingType = null;
                for (i = 0; FilterGroup.coatingTypes !== null && i < defaultConfigGroup.coatingTypes.length; i++) {
                    rType = defaultConfigGroup.coatingTypes[i];
                    for (j = 0; j < FilterGroup.coatingTypes.length; j++) {
                        if (FilterGroup.coatingTypes[j]._id === rType) {
                            if (FilterGroup.filters.coatingType === null) {
                                FilterGroup.filters.coatingType = [];
                            }
                            if (FilterGroup.filters.coatingType.indexOf(FilterGroup.coatingTypes[j]) < 0) {
                                FilterGroup.filters.coatingType.push(FilterGroup.coatingTypes[j]);
                            }
                            break;
                        }
                    }
                }
            }

            // Load default joineryType
            if (defaultConfigGroup.joineryTypes && defaultConfigGroup.joineryTypes !== null) {
                FilterGroup.filters.joineryType = null;
                for (i = 0; i < defaultConfigGroup.joineryTypes.length; i++) {
                    rType = defaultConfigGroup.joineryTypes[i];
                    for (j = 0; j < FilterGroup.joineryTypes.length; j++) {
                        if (FilterGroup.joineryTypes[j]._id === rType) {
                            if (FilterGroup.filters.joineryType === null) {
                                FilterGroup.filters.joineryType = [];
                            }
                            if (FilterGroup.filters.joineryType.indexOf(FilterGroup.joineryTypes[j]) < 0) {
                                FilterGroup.filters.joineryType.push(FilterGroup.joineryTypes[j]);
                            }
                            break;
                        }
                    }
                }
            }

            //Load default technicalElementType
            if (defaultConfigGroup.technicalElementTypes && defaultConfigGroup.technicalElementTypes !== null) {
                FilterGroup.filters.technicalElementType = null;
                for (i = 0; i < defaultConfigGroup.technicalElementTypes.length; i++) {
                    rType = defaultConfigGroup.technicalElementTypes[i];
                    for (j = 0; j < FilterGroup.technicalElementTypes.length; j++) {
                        if (FilterGroup.technicalElementTypes[j]._id === rType) {
                            if (FilterGroup.filters.technicalElementType === null) {
                                FilterGroup.filters.technicalElementType = [];
                            }
                            if (FilterGroup.filters.technicalElementType.indexOf(FilterGroup.technicalElementTypes[j]) < 0) {
                                FilterGroup.filters.technicalElementType.push(FilterGroup.technicalElementTypes[j]);
                            }
                            break;
                        }
                    }
                }
            }
        }
    };

    static updateArrangementPlinthCoating(coating: any, objectTypeList: any[]) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        var entities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);
        if (entities.length === 0) {
            entities = FilterGroup.collectCustomizableEntities(instance.world.currentScene.currentFloor.iArrangements);
        }

        for (var i = 0; i < entities.length; ++i) {
            var item = entities[i];

            if (objectTypeList.indexOf(item.objectType) === -1) {
                continue;
            }

            var coatings = item.getComponents(Savane.ComponentConstants.ComponentType.Coating);

            for (var j = 0; j < coatings.length; j++) {
                if (coatings[j].hangType === Savane.Coating.HangType.kitchenplinth) {
                    // Remove previous coating
                    item.removeComponent(coatings[j]);
                    break;
                }
            }

            var coatingComponent;
            if (coating.colors !== undefined) {
                coatingComponent = new Savane.Coating(coating._id, coating.manufacturer, coating.retailer, Savane.Coating.HangType.kitchenplinth, [coating.colors], coating.randomization, coating.isHpFloorGenerator ? coating.hpFloorGeneratorSettings : undefined);
            }
            else {
                coatingComponent = new Savane.Coating(coating._id, coating.manufacturer, coating.retailer, Savane.Coating.HangType.kitchenplinth, coating.configs, coating.randomization, coating.isHpFloorGenerator ? coating.hpFloorGeneratorSettings : undefined);
            }
            item.addComponent(coatingComponent);
            EntityDefaultPropertiesManager.getInstance().setDefaultCoating('Plinthe', coating._id, item.manufacturer.name, item.objectType);

            PlanManager.getInstance().saveInCache();

            // Regenerate hull to update the plinth color
            Savane.eventsManager.instance.dispatch(Savane.Events.PROJECT_REFRESH_HULL);
        }
    };

    static isPlinthCoatingUsed(coating: any, objectTypeList: any[]) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return false;
        }

        if (FilterGroup.cache.name !== 'Plinthes') {
            FilterGroup.cache.name = 'Plinthes';
            FilterGroup.cache.list = [];

            var entities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);
            if (entities.length === 0) {
                entities = FilterGroup.collectCustomizableEntities(instance.world.currentScene.currentFloor.iArrangements);
            }

            for (var i = 0; i < entities.length; ++i) {
                var item = entities[i];

                if (objectTypeList.indexOf(item.objectType) === -1) {
                    continue;
                }

                var coatings = item.getComponents(Savane.ComponentConstants.ComponentType.Coating);

                for (var j = 0; j < coatings.length; j++) {
                    if ((coatings[j].hangType === Savane.Coating.HangType.kitchenplinth) && (FilterGroup.cache.list.indexOf(coatings[j]._coatingId) === -1)) {
                        FilterGroup.cache.list.push(coatings[j]._coatingId);
                    }
                }
            }
        }

        return (FilterGroup.cache.list.indexOf(coating._id) !== -1);
    };

    static isKitchenArrangement(arrangement: any) {
        if (arrangement.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureBottom ||
            arrangement.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureTop ||
            arrangement.objectType === Savane.SceneConstants.ArrangementType.kitchenFurnitureColumn) {
            return (true);
        }
        else {
            return (false);
        }
    };

    static isStorageArrangement(arrangement: any) {
        return arrangement.objectType === Savane.SceneConstants.ArrangementType.storageCustomizableArrangements.includes(arrangement.objectType);
    };

    static isBathroomArrangement(arrangement: any) {
        return arrangement.objectType === Savane.SceneConstants.ArrangementType.bathroomCustomizableArrangements.includes(arrangement.objectType);
    };



    static updateFilters(filters: FiltersData): Promise<void> {
        const promise = new Promise<void>((resolve) => {
            if (!FiltersWidget.currentFiltersGroup) {
                resolve();
                return;
            }
            //Save filters
            FilterGroup.saveFilters[FiltersWidget.currentFiltersGroup.id] = filters;
            //Process filters to results
            let stringFilters = FiltersWidget.currentFiltersGroup.generateStringFilter();

            if (filters.useColorSearch) {
                stringFilters += '&color=' + encodeURIComponent(filters.color) + '&color2=undefined&count=50&distance=2000&q.pipeline.state.eq=available';
                if (FiltersWidget.currentFiltersGroup.id === "assets") {
                    stringFilters += "&q.kind.eq=Arrangement";
                } else {
                    stringFilters += "&q.kind.eq=Coating";
                }
            }

            let postSortCallback: Function | null = null;
            if (FiltersWidget.currentFiltersGroup.name === 'Shopping list'/* && user.platforms_id !== 1*/) {
                let postSortTemplate = () => { };
                postSortCallback = postSortTemplate;
            }

            if (FilterGroup.smartSearch()) {
                if (filters.name) {
                    FiltersWidget.getDecorationService().setFilters('magicsearch', stringFilters, postSortCallback);
                }
                else {
                    FiltersWidget.getDecorationService().setFilters(FiltersWidget.currentFiltersGroup.resource, stringFilters, postSortCallback);
                }
            }
            else {
                FiltersWidget.getDecorationService().setFilters(FiltersWidget.currentFiltersGroup.resource, stringFilters, postSortCallback);
            }
            resolve();
            setTimeout(function () {
                // Resize WebGL
                Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
            });
        });
        return promise;
    }

    static selectTemplate(template: any): Promise<void> {
        const promise = new Promise<void>((resolve) => {
            if (!FiltersWidget.currentFiltersGroup) {
                console.error("No current filters group found.");
                resolve();
                return;
            }
            let url = AssetManagerServices.ARRMGR_URL + 'api/v1/templates/' + template._id + '?' + AssetManagerServices.ARRMGR_API_KEY + '&fields=_id,groups,associations.asset,associations.placeholder,associations.visibility,customizations.part,customizations.coating';

            FilterGroup.selectedTemplate = template;
            Savane.HttpService.get(url).then((response: any) => {
                let item = response.data;
                let assets: any[] = [];

                if (item.associations) {
                    for (let i = 0; i < item.associations.length; ++i) {
                        if (item.associations[i].asset && item.associations[i].visibility) {
                            assets.push(item.associations[i].asset._id);
                        }
                    }
                }

                FilterGroup.filters.assets = assets;
                FiltersWidget.currentFiltersGroup.resource = AssetManagerServices._ASSET_TYPE.ALL;
                FiltersWidget.getDecorationService().group = AssetManagerServices._ASSET_TYPE.ALL;

                if (FiltersWidget.getDecorationService().displayGroups && item.groups && item.groups.length > 0) {
                    FilterGroup.filters.assets = item.groups;
                    FiltersWidget.currentFiltersGroup.resource = "assets_groups";
                    FiltersWidget.getDecorationService().group = AssetManagerServices._ASSET_TYPE.TEMPLATES;
                }

                if (item.customizations && item.customizations.length > 0) {
                    // Push template customizations
                    for (let i = 0; i < item.customizations.length; i++) {
                        EntityDefaultPropertiesManager.getInstance().setDefaultCoating(item.customizations[i].part, item.customizations[i].coating._id, item.customizations[i].coating.manufacturer.name, item.objectType);
                        if (item.customizations[i].part === 'Porte') {
                            let custoGroups: any[] = [];
                            for (let j = 0; j < item.customizations[i].coating.customizationGroups.length; j++) {
                                custoGroups.push({ _id: item.customizations[i].coating.customizationGroups[j] });
                            }
                            EntityDefaultPropertiesManager.getInstance().setDoorCustomizationGroups(custoGroups);
                        }
                        if (item.customizations[i].part === 'Caisson') {
                            EntityDefaultPropertiesManager.getInstance().setDefaultCoating('Plinthe', item.customizations[i].coating._id, item.customizations[i].coating.manufacturer.name, item.objectType);
                        }
                    }
                }
                if (item.associations && item.associations.length > 0) {
                    // Search for a handle and set it to EntityDefaultPropertiesManager
                    for (let i = 0; i < item.associations.length; i++) {
                        if (item.associations[i].placeholder.objectType === '5d00daa0b846d52308a350e4') {
                            if (item.associations[i].asset) {
                                EntityDefaultPropertiesManager.getInstance().setDefaultHandle(item.associations[i].asset._id, item.associations[i].asset.objectType);
                            }
                            break;
                        }
                    }
                }

                FilterGroup.updateFilters(FilterGroup.filters).then(() => resolve());
                setTimeout(function () {
                    FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                    Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                });
            }, (err: any) => {
                console.log(err);
            });
        });
        return promise;
    }

    static generatePagination(totalRows: number, limit: number, currentPage: number) {
        let nbPages = Math.ceil(totalRows / (limit > 0 ? limit : 1)),
            pagin: { list: any[], nbPages: number, currentPage: number } =
            {
                list: [],
                nbPages: nbPages,
                currentPage: currentPage
            };

        for (let i = 0; i < nbPages; i++) {
            let currentIndex = (i + 1);

            pagin.list.push({
                index: currentIndex,
                active: (currentPage === currentIndex)
            });
        }
        return pagin;
    };

    static cachedTemplateList: any[] = [];

    static updateTemplates(filters: FiltersData): Promise<void> {
        const promise = new Promise<void>((resolve) => {
            if (!FiltersWidget.currentFiltersGroup) { resolve(); return; }

            FilterGroup.saveFilters[FiltersWidget.currentFiltersGroup.id] = filters;
            let styles: any[] = [];
            for (let i = 0; filters.style && i < filters.style.length; ++i) {
                styles.push(filters.style[i]._id);
            }
            let roomTypes: any[] = [];
            for (let i = 0; filters.roomType && i < filters.roomType.length; ++i) {
                roomTypes.push(filters.roomType[i]._id);
            }
            // FilterGroup.currentPage = 1;
            // FilterGroup.projectResults = null;
            if (FilterGroup.selectedTemplate) {
                FilterGroup.selectTemplate(FilterGroup.selectedTemplate);
            }
            FilterGroup.currentPage = 1;
            AssetManagerServices.getTemplates(styles, roomTypes, '&fields=name,_id&sort=name', FilterGroup.currentPage, 40, function (result: any) {
                if (result) {

                    FilterGroup.pagination = FilterGroup.generatePagination(result.totalRows, result.limit, FilterGroup.currentPage);
                } else {
                    FilterGroup.pagination = null;
                }
                FilterGroup.projectResults = result.resources;
                resolve();
                setTimeout(function () {
                    setTimeout(function () {
                        FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                        Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                    });
                });
            });
        });
        return promise;
    };

    static getProjects(styles, roomtypes, page: number, limit: number) {
        let promise = new Promise<any | null>((resolve) => {
            let uri = (typeof HP_CONFIG !== 'undefined') ? HP_CONFIG.APIUri : '//api.rhinovplanner.com/';
            let url = uri + "bo/v2/deliverables?sort=-deliverables.id&q.users.platforms_id.in=1&q.deliverables.deliverable_states_id.in=5,6&medias=1";
            if (styles.length > 0) {
                url += '&q.deliverables.inspiration_id.eq=' + styles[0];
                if (styles.length > 1) {
                    url += '&q.deliverables.secondary_inspiration_id.eq=' + styles[1]
                }
            }
            if (roomtypes.length > 0) {
                url += '&q.deliverables.room_type.in=' + roomtypes;
            }
            const headers = { 'Authorization': `Bearer ${FiltersWidget.user.token}` };
            fetch(`${url}&page=${page}&limit=${limit}`, { headers })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => resolve(data))
                .catch(() => resolve(null));
        });
        return promise;
    }

    static updateProjects(filters: FiltersData) {
        let promise = new Promise<void>((resolve) => {
            let styles: any[] = [];
            for (let i = 0; filters.style && i < filters.style.length; ++i) {
                styles.push(filters.style[i].id);
            }
            let roomTypes: any[] = [];
            for (let i = 0; filters.roomType && i < filters.roomType.length; ++i) {
                roomTypes.push(filters.roomType[i].id);
            }
            FilterGroup.currentPage = 1;
            FilterGroup.projectResults = null;
            FilterGroup.getProjects(styles, roomTypes, 1, 20).then((result: any) => {
                if (result) {
                    FilterGroup.pagination = FilterGroup.generatePagination(result['x-total-count'], 20, FilterGroup.currentPage);
                    FilterGroup.projectResults = result['data'];
                } else {
                    FilterGroup.pagination = null;
                    FilterGroup.projectResults = null;
                }
                resolve();
                setTimeout(function () {
                    setTimeout(function () {
                        FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                        Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                    });
                });
            });
        });

        return promise;
    };

    static updatePinboards(filters: FiltersData) {
        let promise = new Promise<void>((resolve) => {
            FilterGroup.currentPage = 1;
            FilterGroup.pinboards = [];

            if (!FiltersWidget.designer) {
                resolve();
                return;
            }

            AssetManagerServices.getPinboards(filters.public_pinboards, FiltersWidget.designer.mail, 1, 20, function (result: any) {
                if (result) {
                    FilterGroup.pagination = FilterGroup.generatePagination(result['totalRows'], 20, FilterGroup.currentPage);
                    FilterGroup.pinboards = result['resources'];
                } else {
                    FilterGroup.pagination = null;
                    FilterGroup.pinboards = [];
                }

                if (FiltersWidget.currentFiltersGroup.id === 'pinboards') {
                    let group = FiltersWidget.currentFiltersGroup as PinBoardsFilterWidget;
                    group.updatePinboardsTable();
                }

                FilterGroup.updateFilters(FilterGroup.filters).then(() => resolve());
                setTimeout(function () {
                    setTimeout(function () {
                        FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                        Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                    });
                });
            });
        });
        return promise;
    }

    static updateAssetsGroupsLists(filters: FiltersData) {
        const promise = new Promise<void>((resolve) => {
            FilterGroup.currentPage = 1;
            FilterGroup.assets_groups = null;

            if (!FiltersWidget.designer) {
                resolve();
                return;
            }

            AssetManagerServices.getAssetsGroupsLists(filters.public_groups, FiltersWidget.designer.mail, 1, 20, function (result: any) {
                if (result) {
                    FilterGroup.pagination = FilterGroup.generatePagination(result['totalRows'], 20, FilterGroup.currentPage);
                    FilterGroup.assets_groups = result['resources'];
                } else {
                    FilterGroup.pagination = null;
                    FilterGroup.assets_groups = null;
                }
                if (FiltersWidget.currentFiltersGroup.id === 'groups') {
                    let group = FiltersWidget.currentFiltersGroup as GroupsFilterWidget;
                    group.updateGroupsTableHtml();
                }
                setTimeout(function () {
                    setTimeout(function () {
                        FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                        Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                    });
                });
                FilterGroup.updateFilters(FilterGroup.filters).then(() => resolve());
            });
        });
        return promise;
    }

    static updateFunctions: Record<string, (filters: FiltersData) => Promise<void>> = {
        "updateFilters": FilterGroup.updateFilters,
        "updateTemplates": FilterGroup.updateTemplates,
        "updateProjects": FilterGroup.updateProjects,
        "updatePinboards": FilterGroup.updatePinboards,
        "updateAssetsGroupsLists": FilterGroup.updateAssetsGroupsLists
    };

    static getUpdateFunctions(name: string): (filters: FiltersData) => Promise<void> {
        return FilterGroup.updateFunctions[name];
    };

    static destroy() {
        // Savane.eventsManager.instance.removeListener(webGLCameraChangeListener);

        Savane.eventsManager.instance.removeListener(FilterGroup.resultListener);
        Savane.eventsManager.instance.removeListener(FilterGroup.setFilters);
        Savane.eventsManager.instance.removeListener(FilterGroup.enableObjectFilters);
        clearInterval(FilterGroup.selectedEntitiesWatcher);
    };
}